import { Injectable, computed, signal } from '@angular/core';

import { Theme } from '../../admin/models/';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private _currentTheme = signal<Theme | null>(null);
  public currentTheme = computed(() => this._currentTheme());

  setTheme(theme: Theme) {
    this._currentTheme.set(theme);
  }
}
